/* eslint-disable */
/* Автогенерация: npm start / npm run build → scripts/write-app-version.cjs */
export const CLIENT_BUILD_ID = "movpgitf-ec0ddf6fb2979cbe";
export const CLIENT_APP_VERSION = "1.0.1";
